import { Injectable } from '@angular/core';
import { IJob } from '@shared-models/job.model';
import { Provider } from '@shared-providers/Provider';
import { Api } from '@shared-providers/api.provider';
import { LoadingService } from '@shared-services/loading.service';

@Injectable({
	providedIn: 'root',
})
export class JobProvider extends Provider<IJob> {
	protected readonly url: string = '/jobs';

	constructor(
		protected readonly api: Api,
		protected readonly loadingService: LoadingService
	) {
		super(loadingService);
	}

	public async getOne(jobId: string): Promise<IJob> {
		return this.process(this.api.get(`${this.url}/${jobId}`), false) as Promise<IJob>;
	}

	public async getLastRunning(): Promise<IJob> {
		return this.process(this.api.get(`${this.url}/last`), false) as Promise<IJob>;
	}

	public deleteOne(jobId: string): Promise<void> {
		return this.process(this.api.delete(`${this.url}/${jobId}`), false) as Promise<void>;
	}
}
